// ============================================================
// CLEAN TOKENS MODULE - single source for every new surface
// Round 1 of 5 - AdGalaxy Clean UI Rebuild
// ============================================================

export const ORANGE = '#FF5B00';

export const T = {
  bg:    '#FAF8F4',
  card:  '#FFFFFF',
  ink:   '#17130E',
  sub:   '#6E675D',
  faint: '#A39A8D',
  line:  '#ECE6DC',
  soft:  '#F4EFE8',
  green: '#1FA65A',
  amber: '#DE9B00',
  red:   '#E5484D',
  gold:  '#B98900',
  blue:  '#2E6BE6',
} as const;

export const BODY = "'Poppins', sans-serif";
export const MONO = "'Poppins', sans-serif";

// Agent accent colours by id (0-11)
export const ACOL: string[] = [
  '#6B7D4E', // 0 CHIEF
  '#4C9E3F', // 1 SCOUT
  '#2E86C9', // 2 ANALYST
  '#D89B00', // 3 ANGLE
  '#D6588C', // 4 SCRIBE
  '#FF5B00', // 5 HOOK
  '#7A5BD6', // 6 SCENE
  '#D6455F', // 7 PIXEL
  '#1F9BA3', // 8 EDITOR
  '#5F6FD6', // 9 DOOMER
  '#2E6BE6', // 10 LAUNCHER
  '#1FA67E', // 11 LEARNER
  '#8B5CF6', // 12 STORYBOARD
];

// Agent definitions (for Monogram)
export const AGENTS = [
  { id: 0,  code: 'CH', role: 'Line manager' },
  { id: 1,  code: 'SC', role: 'Research' },
  { id: 2,  code: 'AN', role: 'Ad forensics' },
  { id: 3,  code: 'AG', role: 'Angles' },
  { id: 4,  code: 'SR', role: 'Copy' },
  { id: 5,  code: 'HK', role: 'Hooks' },
  { id: 6,  code: 'SN', role: 'Storyboard' },
  { id: 7,  code: 'PX', role: 'Renders' },
  { id: 8,  code: 'ED', role: 'Cut and pace' },
  { id: 9,  code: 'DO', role: 'Skeptic QA' },
  { id: 10, code: 'LA', role: 'Meta upload' },
  { id: 11, code: 'LR', role: 'Nightly learnings' },
  { id: 12, code: 'SB', role: 'Video shot planner' },
];

// Health state colours and labels
export const HEALTH = {
  good:      [T.green, 'On track'],
  attention: [T.amber, 'Needs you'],
  stopped:   [T.red,   'Stopped'],
} as const;

// Station names (1-indexed, 11 for video, 10 for image skipping EDITOR)
export const STN = ['SCOUT', 'ANALYST', 'ANGLE', 'SCRIBE', 'HOOK', 'SCENE', 'PIXEL', 'EDITOR', 'DOOMER', 'REVIEW', 'LAUNCH'];

// Shared style objects
export const cardStyle = {
  background: T.card,
  border: `1px solid ${T.line}`,
  borderRadius: 16,
} as const;

export const labelStyle = {
  fontFamily: BODY,
  fontSize: 8.5,
  letterSpacing: 1.6,
  color: T.faint,
  textTransform: 'uppercase' as const,
};

export const btnPrimary = {
  background: ORANGE,
  color: '#FFF',
  border: 'none',
  borderRadius: 10,
  fontFamily: BODY,
  fontWeight: 600,
  fontSize: 11.5,
  padding: '9px 15px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  cursor: 'pointer',
} as const;

export const btnGhost = (col: string = T.sub) => ({
  background: 'transparent',
  color: col,
  border: `1px solid ${T.line}`,
  borderRadius: 10,
  fontFamily: BODY,
  fontWeight: 500,
  fontSize: 11,
  padding: '7px 12px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  cursor: 'pointer',
} as const);

// Level maths - unchanged economy, base 60 XP, multiply by 1.062 per level, cap 99
export function lvlOf(xp: number): { l: number; pct: number } {
  let l = 1;
  let need = 60;
  let left = xp;
  while (left >= need && l < 99) {
    left -= need;
    need = Math.round(need * 1.062);
    l++;
  }
  return { l, pct: Math.min(100, Math.round((left / need) * 100)) };
}

export function cap(x: string): string {
  return x.charAt(0).toUpperCase() + x.slice(1);
}
